import CheckmarkSvg from "src/components/svg/CheckMarkSvg";
import StarSvg from "src/components/svg/StarSvg";
import classNames from 'classnames';
import styles from './CSSPanelStyles.module.css';

export function SRatingContainer({ className, ...rest }: React.ComponentProps<'div'>) {
    return <div className={classNames(styles.SRatingContainer, className)} {...rest} />;
}

export function SEditorContainer({ className, ...rest }: React.ComponentProps<'div'>) {
    return <div className={classNames(styles.SEditorContainer, className)} {...rest} />;
}

export function SRatingStar({ className, ...rest }: React.ComponentProps<typeof StarSvg>) {
    return <StarSvg className={classNames(styles.SRatingStar, className)} {...rest} />;
}

export function SRatingButton({ className, ...rest }: React.ComponentProps<'button'>) {
    return <button className={classNames(styles.SRatingButton, className)} {...rest} />;
}

export function SReviewActions({ className, ...rest }: React.ComponentProps<'div'>) {
    return <div className={classNames(styles.SReviewActions, className)} {...rest} />;
}

export function SSaveContainer({ className, ...rest }: React.ComponentProps<'span'>) {
    return <span className={classNames(styles.SSaveContainer, className)} {...rest} />;
}

export function SSavedCheckMark({ className, ...rest }: React.ComponentProps<typeof CheckmarkSvg>) {
    return <CheckmarkSvg className={classNames(styles.SSavedCheckMark, className)} {...rest} />;
}

export function SErrorMessage({ className, ...rest }: React.ComponentProps<'div'>) {
    return <div className={classNames(styles.SErrorMessage, className)} {...rest} />;
}

